import { call, put, takeEvery } from 'redux-saga/effects';
import * as W from '../actions/widgetActions';
import * as storage from 'utils/storage';
import Api from 'api/widgets';

export function* fetchWidgetDetailsSaga(action) {
  try {
    const accessToken = JSON.parse(storage.getStorageItem('accessToken', '""'));
    const { widgetId } = action.payload;
    const response = yield call(Api.fetchWidgetDetails(widgetId), {
      headers: { 'x-blu-jwt': `${accessToken}` },
    });
    yield put({ type: W.fetchWidgetDetails.success, payload: response.data });
  } catch (error) {
    const err = error as Error;
    yield put({ type: W.fetchWidgetDetails.failure, payload: err.message });
  }
}

export function* saveWidgetPlacementSaga(action) {
  try {
    const accessToken = JSON.parse(storage.getStorageItem('accessToken', '""'));
    yield call(Api.saveWidgetPlacement, {
      headers: { 'x-blu-jwt': `${accessToken}` },
      data: action.payload,
    });
    yield put({ type: W.saveWidgetPlacement.success });
  } catch (error) {
    const err = error as Error;
    yield put({ type: W.saveWidgetPlacement.failure, payload: err.message });
  }
}

export function* fetchDeviceReadingSaga(action) {
  try {
    const accessToken = JSON.parse(storage.getStorageItem('accessToken', '""'));
    const response = yield call(Api.fetchDeviceReading(action.payload.deviceId), {
      headers: { 'x-blu-jwt': `${accessToken}` },
    });
    yield put({ type: W.fetchDeviceReading.success, payload: response.data });
  } catch (error) {
    const err = error as Error;
    yield put({ type: W.fetchDeviceReading.failure, payload: err.message });
  }
}

export function* watchFetchDeviceReading() {
  yield takeEvery(W.fetchDeviceReading.request, fetchDeviceReadingSaga);
}

export function* watchSaveWidgetPlacement() {
  yield takeEvery(W.saveWidgetPlacement.request, saveWidgetPlacementSaga);
}

export function* watchFetchWidgetDetails() {
  yield takeEvery(W.fetchWidgetDetails.request, fetchWidgetDetailsSaga);
}
